import trackingDefaultDataTypesHydrator from './trackingDefaultDataTypes';
import trackingPages from './visitsTracking/trackingPages';

export default async (options) => ({
    ...trackingPages(),
    ...await trackingDefaultDataTypesHydrator(options),
});